// Modules
import { FieldArray, Field } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';

import { ADDRESS_TYPES, STATES } from 'constants';
import { RemoveButton } from 'components/widgets/buttons';
import { Row, Subform, SubformHeader } from 'components/forms/form-structure';
import { TextInput, SelectInput, CheckboxInput } from 'components/forms/form-elements';
import { convertArrayToOptions } from 'utils/input-utils';
import { preventDefault } from 'utils/event-handlers';

class RenderAddresses extends React.Component {
  static propTypes = {
    fields: PropTypes.object,
    change: PropTypes.func,
    meta: PropTypes.object,
    allowBilling: PropTypes.bool
  };

  constructor() {
    super();

    this.inputs = [];
    this.setBilling = this.setBilling.bind(this);
  }

  setBilling(event, index) {
    if (!event.target.checked) return;

    const { fields, change } = this.props;

    fields.forEach((name, fieldIndex) => {
      if (fieldIndex !== index) change(`${name}.billing`, false);
    });
  }
  
  render() {
    const { fields, meta, allowBilling } = this.props;

    const helpText = (
      <div>
        <p>
          Always use address name for clients with multiple offices. Use the city of each office as the office name.
          If the client has multiple offices in the same city ask your team lead to confirm proper naming.
        </p>
        <div className="examples">
          <p>"Bellevue"</p>
          <p>"South Auburn"</p>
          <p>"North Auburn"</p>
        </div>
      </div>
    );

    return (
      <Subform>
        <SubformHeader>
          Addresses
          { meta.error && meta.error !== ' ' && <div className="invalid-alert">{meta.error}</div> }
        </SubformHeader>
        <div className="address-input-list">
          { fields.map((name, index) =>
            <div key={index} className="address-input-group">
              <Row>
                <Field component={TextInput} placeholder="name" name={`${name}.name`} helpText={helpText} />
                <Field component={SelectInput} placeholder="type" name={`${name}.type`} elementClasses="type-select" options={convertArrayToOptions(ADDRESS_TYPES)} />
                <span className="billing-address-select">
                  { allowBilling &&
                    <Field
                      component={CheckboxInput}
                      label="Billing"
                      name={`${name}.billing`}
                      onChange={(event) => this.setBilling(event, index)}
                    />
                  }
                  <RemoveButton onClick={() => fields.remove(index)} className="margin-left" />
                </span>
              </Row>
              <Field component={TextInput} placeholder="address" name={`${name}.address`} autoFocus={fields.get(index).isNew} />
              <Field component={TextInput} placeholder="suite or unit" name={`${name}.line2`} />
              <div className="form-flex-row">
                <Field component={TextInput} placeholder="city" name={`${name}.city`} />
                <Field component={SelectInput} matchPos="start" inputProps={{ autoComplete: 'off' }} placeholder="state" name={`${name}.state`} options={STATES} />
                <Field component={TextInput} placeholder="zip" name={`${name}.zip`} />
              </div>
            </div>
          ) }
          <a href="" onClick={preventDefault(() => fields.push({ billing: !fields.length && allowBilling, isNew: true }))}>Add Address</a>
        </div>
      </Subform>
    );
  }
}

RenderAddresses.propTypes = {
  fields: PropTypes.object
};

// Component
export default function AddressForm(props) {
  return <FieldArray {...props} component={RenderAddresses} name="addresses" />;
}



// WEBPACK FOOTER //
// ./app/components/models/person/address-form.js